<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    viewBox="0 0 32 32"
    :width="size"
    :height="size"
  >
    <path
      d="M28.115 4.336l-16.337 16.337-7.225-7.225-3.771 3.771 10.996 10.997 20.108-20.108-3.771-3.772z"
      fill="#9db81d"
    />
  </svg>
</template>

<script>
export default {
  name: 'SvgCheck',

  props: {
    size: {
      type: [Number, String],
      default: 32,
    },
  },
}
</script>
